<div class="content-without-stepper-and-title document-introduction">
  <div class="row">
    <div class="col-4 col-pr-12 col-sm-8 col-md-12 col-lg-12 col-xl-12">
      <div class="image">
        <img id="docIntroImg" src="assets/images/document_introduction.jpg" alt="{{copyService.copies.document_introduction_alt_image}}" />
      </div>
      <div id="docIntroTitle" class="title" [innerHTML]="copyService.copies.document_introduction_title"></div>
    </div>
  </div>
  <app-controls id="docIntroBtns" [hasPrevious]="true" [nextLabel]="copyService.copies.document_introduction_btn" (next)="next()"></app-controls>
</div>
